import axios from '@/lib/axios';
import { Product } from '@/hooks/api/models';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 0390. 売上カテゴリ一覧
 * [GET] /workspaces/:identifier/products
 */
type Props = {
  identifier: string;
  include_invalidity?: boolean;
};

const products = (props: Props): Promise<Product[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/products`, { params: props });
};

export const useProducts = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => products(props),
  });
};

export const useInvalidateProducts = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  const keys: (string | boolean)[] = ['workspaces', props.identifier, 'products'];
  if (props.include_invalidity) {
    keys.push(props.include_invalidity);
  }
  return keys;
};
